import React from "react";
import { PatternBackground } from "../../components/PatternBackground";
import { useProfiles } from "../../hooks/api/useProfile";
import { useMemberRequestSummary } from "../../hooks/api/useMemberRequestSummary";
import MemberRequestsTable from "./MemberRequestsTable";

export const MemberRequestPage = () => {
  const { data: profiles, isLoading: profilesLoading } = useProfiles();
  const activeProfile = profiles?.find((p) => p.active) || profiles?.[0];
  const employerNumber = activeProfile?.employerNumber;

  const { data: summary, isLoading: summaryLoading } =
    useMemberRequestSummary(employerNumber);

  const isLoading = profilesLoading || summaryLoading;

  const cards = [
    {
      label: "Total Requests",
      value: summary?.totalRequests ?? 0,
      color: "#1f2937",
      bg: "#f8fafc",
      icon: "bi-people-fill",
      iconBg: "#e2e8f0",
    },
    {
      label: "Pending",
      value: summary?.pendingRequests ?? 0,
      color: "#b45309",
      bg: "#fffbeb",
      icon: "bi-hourglass-split",
      iconBg: "#fde68a",
    },
    {
      label: "Approved",
      value: summary?.approvedRequests ?? 0,
      color: "#047857",
      bg: "#ecfdf5",
      icon: "bi-check-circle-fill",
      iconBg: "#a7f3d0",
    },
    {
      label: "Rejected",
      value: summary?.rejectedRequests ?? 0,
      color: "#b91c1c",
      bg: "#fef2f2",
      icon: "bi-x-circle-fill",
      iconBg: "#fecaca",
    },
  ];

  return (
    <div className="">
      <PatternBackground>
        <p className="lead fw-bold">Member Request</p>
        <small>Manage member requests</small>
      </PatternBackground>
      <div className="om-container">
        <div className="p-4 shadow-sm bg-white rounded">
          <div className="row g-3 mb-4">
            {cards.map((c) => (
              <div key={c.label} className="col-12 col-sm-6 col-md-3">
                <div
                  className="d-flex align-items-center gap-3 p-3 h-100"
                  style={{
                    background: c.bg,
                    borderRadius: 16,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                    border: "1px solid rgba(0,0,0,0.03)",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    cursor: "default",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.06)";
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 14,
                      background: c.iconBg,
                      color: c.color,
                      fontSize: 22,
                    }}
                  >
                    <i className={`bi ${c.icon}`} />
                  </div>
                  <div>
                    <div
                      className="fw-bold"
                      style={{ fontSize: 22, lineHeight: 1.1, color: c.color }}
                    >
                      {isLoading ? "-" : c.value}
                    </div>
                    <small
                      className="fw-semibold"
                      style={{ color: c.color, opacity: 0.75, fontSize: 12 }}
                    >
                      {c.label}
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <MemberRequestsTable />
        </div>
      </div>
    </div>
  );
};
